import {
  // -- GET (list)
  GET_SCENARIO_WEATHERS_SUCCESS,
  GET_SCENARIO_WEATHERS_FAILURE,
  // -- CREATE
  CREATE_SCENARIO_WEATHER_SUCCESS,
  CREATE_SCENARIO_WEATHER_FAILURE,
  // -- UPDATE
  UPDATE_SCENARIO_WEATHER_SUCCESS,
  UPDATE_SCENARIO_WEATHER_FAILURE,
  // -- DELETE
  DELETE_SCENARIO_WEATHER_SUCCESS,
  DELETE_SCENARIO_WEATHER_FAILURE,
  // -- SEARCH
  SEARCH_SCENARIO_WEATHERS
} from '../../../actions'
import { Logger, LoggerTypes } from '../../../utils'

let cacheItems = null

export const scenarioWeathers = (state = {}, action) => {
  switch (action.type) {
    // -- GET SCENARIO WEATHERS (list)
    case GET_SCENARIO_WEATHERS_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] scenarioWeathers.GET_SCENARIO_WEATHERS_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case GET_SCENARIO_WEATHERS_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarioWeathers.GET_SCENARIO_WEATHERS_SUCCESS()', { state, action })
      return {
        ...state,
        items: action.data
      }
    }

    // -- CREATE SCENARIO WEATHER
    case CREATE_SCENARIO_WEATHER_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] scenarioWeathers.CREATE_SCENARIO_WEATHER_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case CREATE_SCENARIO_WEATHER_SUCCESS: {
      let newItems = [...state.items]
      newItems.push(action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarioWeathers.CREATE_SCENARIO_WEATHER_SUCCESS()', {
        state,
        action,
        newItems
      })

      return {
        ...state,
        items: newItems
      }
    }

    // -- UPDATE SCENARIO WEATHER
    case UPDATE_SCENARIO_WEATHER_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] scenarioWeathers.UPDATE_SCENARIO_WEATHER_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case UPDATE_SCENARIO_WEATHER_SUCCESS: {
      const items = state.items.map((obj) => [action.data].find((o) => o.id === obj.id) || obj)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarioWeathers.UPDATE_SCENARIO_WEATHER_SUCCESS()', {
        state,
        action,
        items
      })

      return {
        ...state,
        items
      }
    }

    // -- DELETE SCENARIO WEATHER
    case DELETE_SCENARIO_WEATHER_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] scenarioWeathers.DELETE_SCENARIO_WEATHER_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case DELETE_SCENARIO_WEATHER_SUCCESS: {
      const items = state.items.filter((obj) => obj.id !== action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarioWeathers.DELETE_SCENARIO_WEATHER_SUCCESS()', {
        state,
        action,
        items
      })

      return {
        ...state,
        items
      }
    }

    // -- SEARCH SCENARIO
    case SEARCH_SCENARIO_WEATHERS: {
      const txt = action.data || ''
      if (txt.length <= 1 && cacheItems === null && state.items) {
        cacheItems = [...state.items]
      }

      const escapeRegExp = (value) => value && value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
      const searchRegex = new RegExp(escapeRegExp(txt), 'i')
      const searchItems = (cacheItems || []).filter((row) =>
        Object.keys(row).some((field) => searchRegex.test(((row && row[field]) || '').toString()))
      )
      return {
        ...state,
        items: searchItems
      }
    }

    default:
      return state
  }
}
